import React from 'react';
import BSSpinner from 'react-bootstrap/Spinner';
import styled, { keyframes } from 'styled-components';
import Icon from '@/common/view/icons';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

type SpinnerSize = 'xsmall' | 'small' | 'medium';
type SpinnerType = 1 | 2;

const sizeMap: Record<SpinnerSize, string> = {
  xsmall: '1rem',
  small: '1.5rem',
  medium: '2rem',
};

const StyledLoaderBox = styled.div<{ $size: SpinnerSize | string }>`
  display: inline-flex;
  svg {
    width: ${({ $size }) => sizeMap[$size as SpinnerSize] || $size};
    height: ${({ $size }) => sizeMap[$size as SpinnerSize] || $size};
    animation: ${rotate} 1s linear infinite;
    path {
      fill: ${({ theme }) => theme.colors.gray40};
    }
  }
`;
const StyledSpinner = styled(BSSpinner)<{ $size: SpinnerSize }>`
  color: ${({ theme }) => theme.colors.gray30};
  ${({ $size }) => ($size === 'xsmall' ? 'border-width: 2px;' : '')}
  --bs-spinner-width: ${({ $size }) => sizeMap[$size] || $size};
  --bs-spinner-height: ${({ $size }) => sizeMap[$size] || $size};
`;

interface SpinnerProps {
  size?: SpinnerSize | string;
  type?: SpinnerType;
}
const Spinner: React.FC<SpinnerProps> = ({ size = 'medium', type = 1 }) => {
  if (type === 1) {
    return <StyledSpinner animation="border" $size={size as SpinnerSize} />;
  } else if (type === 2) {
    return (
      <StyledLoaderBox $size={size}>
        <Icon.Loader />
      </StyledLoaderBox>
    );
  }
  return null;
};

export default Spinner;
